import React, { useState } from "react";
import { Layout, Typography, Divider, Button, Card, Upload, Space, message, Modal } from "antd";
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import { apiCall, apiDownload } from "../utils/Api";
import { useSession } from "../utils/Session";


export default function StockTitleUploads(props) {

    // Flag to change title and enable excel download
    const { management = false } = props;
    const [session, setSession] = useSession();

    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);


    const onRemove = (_file) => {
        setFileList([]);
    }

    // disables auto sending file. 
    const beforeUpload = (_file) => {
        setFileList([_file]);
        return false;
    }

    const handleUpload = () => {
        setUploading(true);


        apiCall("interm/upload", { file: fileList[0] }, (_status, _result) => {
            if (_status) {
             
                Modal.success({
                    title : "File uploaded",
                    content : "File uploaded successfully."
                })
            } else {
                message.error("Error: " + _result.error);
            }
            setUploading(false);
            setFileList([])
        })
    }

    if (!(session.has_interm_upload && (session.has_bm_data_full || session.has_bm_data_lite))) {
        return (<></>)
    }

    return (
        <>



            <h2>Stock &amp; Title Uploads</h2>

            <Divider dashed style={{ "margin": "15px 0px" }} />

            <div className="shim" /><div className="shim" />
            <div className="float-flex">
                <p>Use the uploader below to upload your stock or title data information for us to process as an alternative to FTP.</p>
            </div>
            <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
            <div style={{ "padding": "0px" }}>
                <Card>
                    <p>Select a file and click "Start upload"</p>
                    <Space align="start">
                        <Upload  fileList={fileList} multiple={false} onRemove={(_file) => onRemove(_file)} beforeUpload={(_file) => beforeUpload(_file)}>
                            <Button disabled={(fileList.length > 0)} icon={<UploadOutlined />}>Select file</Button>
                        </Upload>
                        <Button
                            type="primary"
                            onClick={handleUpload}
                            disabled={fileList.length === 0}
                            loading={uploading}
                        >
                            {uploading ? 'Uploading' : 'Start upload'}
                        </Button>
                    </Space>
                </Card>
            </div>
        </>
    )
}